import React,{useEffect}  from 'react'
import { useAuthState } from '../../components/AuthProvider'
import styles from './Home.module.scss'
import Content from '../../components/Content'
import Layout from '../../components/Layout'
import getVectorImage from '../../utils/getVectorImage'
import { useNavigate } from 'react-router-dom'
import { Navigate } from 'react-router-dom'
const Home = () => {
  const history = useNavigate()
  const { isAuthenticated,isCreatingSession } = useAuthState()

    useEffect(() => {
    const url  = process.env.REACT_APP_BACKEND_BASE_URL + '/auth_challenge'
    fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    })
      .then((response) => response.json())
      .then((data) => {
        window.localStorage.setItem('CodeChallenge', JSON.stringify(data))        
      })
  }, [])

  if (isAuthenticated) {
    return <Navigate to="/dashboard" />
  } 
  else if (isCreatingSession) {
    return(
      <div>
      Redirecting to dashboard....
      </div>    
    )
  }
  else {
    return (
      <Layout>
        <Content backgroundColor="#D9F6FA">
          <div className={styles.base}>
            <div className={styles.maindivFormat}>
              <div style={{ width: '721px', marginBottom: '-7px' }}>
                {getVectorImage('illustration', '550px', '')}
              </div>
              <div
                style={{ width: '35%', marginTop: '48px', display: 'inline' }}
              >
                <div>
                  <div className={styles.formheader}>
                    Welcome to the Infectious Disease Platform
                  </div>
                  <div className={styles.formheadertitle}>
                    Please choose any option to sign in.{' '}
                  </div>
                </div>
                  <div className={styles.buttondiv}>
                  {' '}
                 
                   <div
                    id="btn-sso-login"
                    className={styles.button}
                    onClick={() => history('/sso-login')}
                  >
                    {' '}
                    Enterprise SSO Sign In{' '}
                  </div>
                </div>
                <div className={styles.buttondiv}>
                  {' '}
                  <div
                    id="btn-ohid-login"
                    className={styles.button}
                    onClick={() => history('/ohid-login')}
                  >
                    {' '}
                    One Healthcare ID Sign In{' '}
                  </div>
                 
                </div>
               
              </div>
            </div>
          </div>
        </Content>
      </Layout>
    )
  }
}
export default Home
